/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Helpers.Browser = class Browser {
  static isSafari() {
    return (navigator.userAgent.match("Safari") != null) && (navigator.userAgent.match("Chrome") == null);
  }

  static safariVersion() {
    if (navigator.userAgent.match("Safari")) {
      const match = navigator.userAgent.match(/Version\/(\d+)\.(\d+)\.?(\d+) Safari/);

      if (match != null) {
        const version = [
          parseInt(match[1], 10),
          parseInt(match[2], 10),
          parseInt(match[3] || 0, 10)
        ];
        return parseFloat(version.join('.'));
      }
    }

    return false;
  }

  static iOSVersion() {
    if (window.MSStream != null) {
      // There is some iOS in Windows Phone...
      // https://msdn.microsoft.com/en-us/library/hh869301(v=vs.85).aspx
      return false;
    }

    const match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (match != null) {
      const version = [
        parseInt(match[1], 10),
        parseInt(match[2], 10),
        parseInt(match[3] || 0, 10)
      ];
      return parseFloat(version.join('.'));
    }

    return false;
  }
};
